import './index.css'
import clsx from 'clsx'

import React from 'react'
import Icon from 'components/ui/icon'
type Props = {
  onClick: (...args: Array<any>) => any
  open: boolean
  count: number
}

const TrackVersionsButton = ({
  onClick,
  open,
  count,
}: Props): React.ReactElement<'div'> => {
  return (
    <div
      className="ExplorerTrackVersionsButton"
      onClick={e => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      <span className="ExplorerTrackVersionsButton__Count">{count}</span>
      <Icon
        className={clsx('ExplorerTrackVersionsButton__Arrow', {
          'ExplorerTrackVersionsButton__Arrow--Open': open,
        })}
        type="arrow-right-compact"
        width={14}
        height={14}
      />
    </div>
  )
}

export default TrackVersionsButton
